export type ClientDetail = {
  email: string;
  company: string;
  inboxState: string;
  subscriptionPlan: string;
  partner: string;
  roles: Array<string>;
  isB4AClient: boolean;
  isMultiBusinessPerson: boolean;
  bookkeeperId: string;
  bookkeeperEmail: string;
  salespersonId: string;
  salespersonEmail: string;
  clientSuccessId: string;
  clientSuccessEmail: string;
};

declare global {
  interface Window {
    BENCH;
  }
}

export enum Source1099 {
  MISC = 'Miscellaneous',
  NEC = 'Non-employee Compensation',
}

export type Report1099Fields = {
  key: number;
  value: unknown;
  onChange: (name: string) => (option: any) => void;
};
